"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Favorites = void 0;
var UserAction = _interopRequireWildcard(require("@ori-events/user-action"));
var _icons = require("@ori-ui/icons");
var _auth = require("@ori/auth");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../../../constants");
var _useFavoritesLinkAndText = require("../../../hooks/useFavoritesLinkAndText");
var _constants2 = require("../constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Favorites = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    isAnonymousUser
  } = (0, _auth.useToken)();
  const {
    favoritesLink,
    favoritesText
  } = (0, _useFavoritesLinkAndText.useFavoritesLinkAndText)();
  const handleAnalytics = (0, _react.useCallback)(() => {
    UserAction.dispatch(_constants.FAVORITES_OVERVIEW_OPEN);
  }, []);
  if (isAnonymousUser) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
    "data-testid": getTestId(_constants2.FAVORITE_LIST_ITEM),
    onClick: handleAnalytics,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.FavoritesRoot, {
      href: favoritesLink,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.HeartIconRoot, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Heart, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.FavoritesTitle, {
        className: "favoritesTitle",
        children: favoritesText
      })]
    })
  });
};
exports.Favorites = Favorites;
